<template>
  <div class="vali">
    <header>
      <van-icon class="back_btn" name="arrow-left" @click="goBack" />
    </header>
    <main>
      <h3>
        请输入验证码
      </h3>
      <div class="vali_content">
        <van-password-input
          :value="value"
          :mask="false"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <!-- 数字键盘 -->
        <van-number-keyboard
          :show="showKeyboard"
          @input="onInput"
          @delete="onDelete"
          @blur="showKeyboard = false"
        />
      </div>
      <div class="vali_button" @click="handleValidate">
        验证
      </div>
    </main>
    <van-popup v-model="show">
      <div class="fail">
        <img src="../../common/images/fail.png" alt="" />
        <h3>验证失败</h3>
        <p>请重试</p>
        <button @click="failCon">确认</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Icon, PasswordInput, NumberKeyboard, Toast, Popup } from "vant";
export default {
  data() {
    return {
      value: "",
      showKeyboard: true,
      show: false,
    };
  },
  components: {
    "van-icon": Icon,
    "van-password-input": PasswordInput,
    "van-number-keyboard": NumberKeyboard,
    "van-popup": Popup,
  },
  created() {
    this.$jsBridge.callHandler("toggleTitleBar", '{"showTitleBar":true}');
    document.title = "老带新推荐";
    // this.$jsBridge.callHandler('toggleTitleBar', '{"showTitleBar":false}');
    // this.$jsBridge.callHandler('dispatchBackBtn');
    // this.$jsBridge.registerhandler('onBackPressed', () => {
    //   this.goBack();
    // });
  },
  methods: {
    //验证失败
    failCon() {
      this.show = false;
      this.value = "";
    },
    //返回
    goBack() {
      this.$router.push({
        name: "progressDetail",
        params: {
          id: this.$route.query.recommendId,
        },
      });
    },
    //输入
    onInput(key) {
      this.value = (this.value + key).slice(0, 6);
    },
    //删除
    onDelete() {
      this.value = this.value.slice(0, this.value.length - 1);
    },
    //验证
    handleValidate() {
      let data = {
        recommendId: this.$route.query.recommendId,
        smsCode: this.value,
      };
      this.$api
        .verifySmsCode(data)
        .then((res) => {
          if (res.body === true) {
            Toast({
              message: "验证成功",
              icon: "checked",
            });

            setTimeout(() => {
              this.$router.push({
                name: "progressDetail",
                params: {
                  id: this.$route.query.recommendId,
                },
              });
            }, 1000);
          } else {
            this.show = true;
          }
        })
        .catch(() => {
          this.show = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.vali {
  padding: 0 20px;
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 99px;
    padding-right: 20px;
    font-size: 36px;
    font-weight: 500;
    align-items: center;
    font-size: 32px;
    .back_btn {
      width: 100px;
      height: 99px;
      font-weight: 500;
      display: inline-flex;
      align-items: center;
      padding: 10px;
    }
  }
  main {
    margin-top: 60px;
    .vali_content {
      margin-top: 94px;
    }
    .vali_button {
      margin-top: 240px;
      height: 88px;
      background: #0d9869;
      border-radius: 46px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .fail {
    width: 540px;
    height: 730px;
    background: #ffffff;
    border-radius: 20px;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    padding: 40px 0 66px 0;
    img {
      width: 320px;
      height: auto;
    }
    h3 {
      font-size: 52px;

      font-weight: 500;
      color: #333333;
    }
    p {
      color: #666666;
      font-size: 28px;
    }
    button {
      margin-top: 80px;
      width: 452px;
      height: 76px;
      background: #0d9869;
      color: #ffffff;
      border-radius: 38px;
      border: none;
    }
  }
}
</style>
